<div mat-dialog-title>
  <h2 class="my-0">
    {{ 'map.map_table.export' | translate }}
  </h2>
</div>
<div mat-dialog-content>
  <form [formGroup]="form">
    <div class="row">
      <div class="col form-field-container">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ 'map.map_table.export_projection' | translate }}</mat-label>
          <mat-select
            formControlName="projection"
            [matTooltip]="getSelectedTooltipInfo(form.get('projection').value)"
            [value]="form.get('projection').getRawValue()"
          >
            <mat-option
              *ngFor="let projection of registeredProjections"
              [value]="projection.code"
              #tooltip="matTooltip"
              matTooltipPosition="right"
              [matTooltip]="getTooltipInfo(projection)"
            >
              {{ getDisplayName(projection) }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('projection').hasError('required')"
            >{{ 'common.required_field' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col form-field-container">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ 'map.map_table.export_format' | translate }}</mat-label>
          <mat-select formControlName="format" required>
            <mat-option
              *ngFor="let format of availableFormats"
              [value]="format"
              matTooltipPosition="right"
            >
              {{ format }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('format').hasError('required')"
            >{{ 'common.required_field' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col form-field-container" *ngIf="availableTypes.length > 1">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ 'map.map_table.export_type' | translate }}</mat-label>
          <mat-select formControlName="type" required>
            <mat-option *ngFor="let type of availableTypes" [value]="type" matTooltipPosition="right">
              {{ 'map.map_table.export_type_' + type | translate }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('type').hasError('required')"
            >{{ 'common.required_field' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>

  <!-- <div class="container-fluid py-3">
    <div class="row" [ngClass]="{ 'mb-4': !!currentTemplate }">
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label> {{ 'map.plotting.title' | translate }}</mat-label>
          <input matInput [(ngModel)]="plotTitle" type="text" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field class="w-100">
          <mat-label> {{ 'map.plotting.select_template' | translate }}</mat-label>
          <mat-select [(ngModel)]="currentTemplate" (selectionChange)="changedSelectedTemplate()">
            <mat-option *ngFor="let template of templateList" [value]="template">{{ template.title }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="currentTemplate" class="pb-4">
      <mat-divider></mat-divider>
    </div>

    <ebw-dynamic-form *ngIf="currentTemplate" formId="formPlot" (formSubmit)="onFormSubmit($event)"></ebw-dynamic-form>
  </div> -->
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false" color="primary" class="mx-2">
    {{ 'common.close' | translate }}
  </button>
  <button mat-flat-button color="primary" class="mx-2" (click)="onExport()">
    {{ 'map.map_table.export' | translate }}
  </button>
</div>
